import * as React from "react";
import { useAuthenticated } from "react-admin";
import { FormsDashboard } from "../../../pages/forms-dashboard";
import { AppContext } from "../../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../../utils/general-profile.enum";
import QuizDashboard from "../quiz-dashboard";
import SchoolStudentDashboard from "../school-student-dashboard";
//import SchoolTeacherDashboard from "../school-teacher-dashboard";
import OfficeTeacherDashboard from "../../../pages/dashboards/office/teacher-dashboard";
import SchoolTeacherDashboard from "../../../pages/dashboards/school/teacher-dashboard";
import StudentDashboard from "../student-dashboard";
import { SchoolManagerDashboard } from "../../../pages/dashboards/school/admin/admin-dashboard";


export const DefaultDashboard = () => {
    useAuthenticated()
    
    const context = React.useContext(AppContext)
    const isStudent = context.profile.name === ProfileEnum.STUDENT
    let tutorialCompletion, tutorialComplete;
    const is_admin = [ProfileEnum.SUPERADMIN, ProfileEnum.GENERAL_PRINCIPAL, ProfileEnum.ADMIN].includes(context.profile.name)
    switch (context.product?.id) {
        case 1:
            //Juristta School
            tutorialCompletion = isStudent ? context.schoolStudentTutorialCompletion : context.schoolManagerTutorialCompletion;
            tutorialComplete = tutorialCompletion ? tutorialCompletion?.findIndex(el => el === false) === -1 : false
            if (isStudent) {
                return <SchoolStudentDashboard tutorialComplete={tutorialComplete} />
            } else if (is_admin) {
                return <SchoolManagerDashboard />
            } else {
                // return <SchoolTeacherDashboard tutorialComplete={tutorialComplete} />
                return <SchoolTeacherDashboard />
            }
        case 2:
            //Juristta Office
            tutorialCompletion = isStudent ? context.officeStudentTutorialCompletion : context.officeStudentTutorialCompletion;
            tutorialComplete = tutorialCompletion ? tutorialCompletion?.findIndex(el => el === false) === -1 : false
            if (isStudent) {
                return <StudentDashboard tutorialComplete={tutorialComplete} />
            }
            else {
                //return <TeacherDashboard tutorialComplete={tutorialComplete} />
                return <OfficeTeacherDashboard />
            }

        case 4:
            //Juristta Quiz
            return <QuizDashboard isStudent={isStudent} />

        default:
            return <FormsDashboard />
    }
}